import { render, staticRenderFns } from "./setOrderList.vue?vue&type=template&id=72ac7bd6&"
import script from "./setOrderList.vue?vue&type=script&lang=js&"
export * from "./setOrderList.vue?vue&type=script&lang=js&"
import style0 from "./setOrderList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setOrderList.vue"
export default component.exports